import * as React from 'react';
const SvgTriangleRounded = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 11 9" fill="none" {...props}>
        <path
            d="M4.201.75c.577-1 2.02-1 2.598 0L9.83 6a1.5 1.5 0 01-1.299 2.25H2.47A1.5 1.5 0 011.169 6L4.202.75z"
            fill="currentColor"
        />
    </svg>
);
export default SvgTriangleRounded;
